module.exports = __webpack_public_path__ + "static/media/semi_cirlce.01504faa.png";